import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { getCloudImageUrl, normalizeBrand, emptyImage } from "../../../utils";

import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import ArrowNext from "../../../images/arrow/luxury_next.png";

const PreviousArrow = (props) => {
  const { className, style, onClick, displayedData, isLastIndex, isFirstIndex } = props;
  const LeftArrow = styled.div`
    &::before {
    content: "" !important;
    }
    img{
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
    }

    @media(max-width: 480px){
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -15px;
      }
    }
  `
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: isFirstIndex ? "none" : "block" }}
      onClick={onClick}
    >
      <KickImage
        src={ArrowPrev}
        alt="..."
      />
    </LeftArrow>
  )
}

const NextArrow = (props) => {
  const { className, style, onClick, isLastIndex, isFirstIndex } = props;
  const RightArrow = styled.div`
    &::before {
    content: "" !important;
    }
    img{
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media(max-width: 480px){
      img {
        right: -25px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: isLastIndex ? "none" : "block" }}
      onClick={onClick}
    >
      <KickImage
        src={ArrowNext}
        alt="..."
      />
    </RightArrow>
  )
}

const onErrorImg = (e, category) => {
  e.target.src = emptyImage(category)
}

const DATA_PER_CARD = 5;

function splitArray(arr, length) {
  let idx = 0;
  let result = [];

  while (idx < arr.length) {
    if (idx % length === 0) result.push([]);

    result[result.length - 1].push(arr[idx++]);
  }
  return result;
}

const openProductDetail = (id, category, slug, history) => {
  const categoryUrl = category === "apparels" ? "apparel" : category === "handbags" ? "luxury" : category;

  history.push(`${categoryUrl}/${id}/${slug}`)
}

const TableSection = ({ title, data, onLoadProduct, history, linkTo }) => {
  const [isLastIndex, setLastIndex] = useState(false);
  const [isLastDesktopIndex, setLastDesktopIndex] = useState(false);
  const [isFirstIndex, setFirstIndex] = useState(true);

  useEffect(() => {
    const payload = {
      params: {
        category: "handbags",
        per_page: 20,
        page: 1
      }
    }

    onLoadProduct(payload, "handbags");
  }, [])

  useEffect(() => {
    if (data.data.length <= 5) setLastIndex(true)
    else setLastIndex(false)
  }, [data.data])

  const sizeOfArray = data.data.length >= 20 ? 20 : data.data.length;
  const maxData = data.data ? data.data.slice(0, sizeOfArray) : [];
  const displayedData = maxData ? splitArray(maxData, DATA_PER_CARD) : [];

  if (data.data.length === 0) return null;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    swipe: true,
    prevArrow: <PreviousArrow isLastIndex={isLastIndex} isFirstIndex={isFirstIndex} />,
    nextArrow: <NextArrow isLastIndex={isLastIndex} isFirstIndex={isFirstIndex} isLastDesktopIndex={isLastDesktopIndex} />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const onChangeSlider = (oldIndex, newIndex) => {
    if (displayedData.length - 2 === newIndex) setLastIndex(true);
    if (newIndex > 0) setFirstIndex(false)
    if (newIndex === 0) {
      setFirstIndex(true);
      setLastIndex(false);
    }
  }

  return (
    <div className="trending-container">
      <h6>{title}</h6>
      <p className="view-all">
        <Link to={linkTo} target="_blank">
          View All
        </Link>
      </p>
      <div className="trending-wrapper">
        <Slider {...settings} beforeChange={onChangeSlider}>
          {
            displayedData.map((data, cardIndex) => (
              <div className="box-wrapper">
                <div className="trending-item-wrapper">
                  {
                    data.map((item, index) => {
                      const category = item.product.category.name;
                      const img_url = item.product_variant_images.length > 0 ? getCloudImageUrl(item.product_variant_images[0].URL, 100) : emptyImage(category);

                      return (
                        <div key={index} className="trending-item" onClick={() => openProductDetail(item.id, category, item.slug, history)}>
                          <div className="item-numbering">
                            <p>
                              {cardIndex * DATA_PER_CARD + index < 9 ? `0${cardIndex * DATA_PER_CARD + index + 1}` : `${cardIndex * DATA_PER_CARD + index + 1}`}
                            </p>
                          </div>
                          <div className="item-products">
                            <KickImage src={img_url} onError={(e) => onErrorImg(e, category)} />
                            <div className="item-product-name">
                              <span>{normalizeBrand(item.product.brand.name)}</span>
                              <span>{item.display_name}</span>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            ))
          }
        </Slider>
      </div>
    </div>
  )
}

export default TableSection;